import * as PIXI from "pixi.js";
import { Coord } from "../../types/Interface";
import Layers from "../../layers/Layers";


export default class Checkbox extends PIXI.Container {
  private Layers = Layers.getInstance();
  private isChecked: boolean = false;
  private checkedSquare: PIXI.Graphics;
  private checkBoxLabel: string
  private color: number;
  private handleFunc: (label: string, v: boolean) => void;

  constructor(coord: Coord, label: string, color: number, useCustomLayer = false, handleFunc = (label: string, v: boolean) => { }) {
    super();
    Object.assign(this, coord);
    this.checkBoxLabel = label;
    this.color = color;
    this.handleFunc = handleFunc

    this.addCheckbox();
    this.addLabel();
    this.addInteractivity();
    !useCustomLayer && this.addToLayer();
  }
  private addToLayer = () => this.Layers.addChild(this);

  private addCheckbox() {
    this.checkedSquare = new PIXI.Graphics();
    this.drawCheckbox();
    this.addChild(this.checkedSquare);
  }
  private addLabel() {
    const text = new PIXI.Text({ text: this.checkBoxLabel });
    text.style.fontSize = 36;
    text.style.fill = this.color;
    text.anchor.set(0, .5);
    text.x = 50;
    text.y = 0;
    this.addChild(text);
  }
  private drawCheckbox() {
    const fillColor = this.isChecked ? this.color : 0xFFFFFF;

    this.checkedSquare.clear()
      .roundRect(0, -20, 40, 40, 10)
      .fill(fillColor)
      .stroke({ width: 2, color: 0x000000 })
  }
  private addInteractivity() {
    this.interactive = true;
    this.cursor = "pointer";
    this.on("mouseup", () => this.handleCheckbox())
    this.on("touchend", () => this.handleCheckbox())
  }
  private handleCheckbox() {
    this.isChecked = !this.isChecked;
    this.handleFunc(this.checkBoxLabel, this.isChecked);
    this.drawCheckbox();
  }
  getIsChecked() {
    return {
      label: this.checkBoxLabel,
      isChecked: this.isChecked
    }
  };
}